export const CollaboratorStatus = {
  Current: { value: "CURRENT", label: "Current" },
  Ended: { value: "ENDED", label: "Ended" },
};

export const CollaboratorStatuses = [
  CollaboratorStatus.Current,
  CollaboratorStatus.Ended,
];

export const CollaboratorStatusesByValue = new Map<string, typeof CollaboratorStatus[keyof typeof CollaboratorStatus]>(
    Object.values(CollaboratorStatus).map((entry) => [entry.value, entry])
);

